import BaseClient from '@/app/model/api/response/baseApiClient'

class ProfitForcastListApi extends BaseClient {
  public getForcastList (year: string, season: string, type: string) {
    const path:string = '/v1/profit/forecast/list'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ year: year, season: season, type: type })
    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new ProfitForcastListApi()
